import { atom } from 'jotai';

import { TransportationTypeFormState } from '~/modules/transportation/types';

const initialState: TransportationTypeFormState = {
  name: '',
  description: '',
};

export const $transportationTypeForm =
  atom<TransportationTypeFormState>(initialState);

export const $resetTransportationTypeForm = atom(null, (get, set) => {
  set($transportationTypeForm, initialState);
});

export const $updateTransportationTypeForm = atom(
  null,
  (get, set, update: Partial<TransportationTypeFormState>) => {
    const currentState = get($transportationTypeForm);
    set($transportationTypeForm, { ...currentState, ...update });
  },
);
